import { Component, OnInit } from '@angular/core';
import { Submitted_entries_receipt } from 'src/app/models/submitted_entries_receipt';
import { CheckoutService } from 'src/app/providers/checkout.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-entries-receipt-without-payment',
  templateUrl: './entries-receipt-without-payment.component.html',
styleUrls:  ['./entries-receipt-without-payment.component.css']
})
export class EntriesReceiptWithoutPaymentComponent  extends SmsAbstractAppPage implements OnInit {

  receipt: Submitted_entries_receipt = new Submitted_entries_receipt({});

  constructor(private checkoutService: CheckoutService) {
    super();
  }

  ngOnInit() {
    this.checkoutService.getSubmitted_entries_receipt().subscribe(receipt => {
      this.receipt = receipt;
    }, error => {
      this.handleError(error);
    });
  }



}
